export namespace SubstanceScreeningResultConstants {
  export const NEGATIVE: string = 'NEGATIVE';
  export const POSITIVE: string = 'POSITIVE';
}
